export default {
    'facility': [
        // {
        //     value: 'PermitNumber',
        //     label: 'Permit Number',
        //     type: 'String'
        // },
        {
            value: 'FacilityID',
            label: 'RBDMS ID',
            type: 'String',
        },
        {
            value: 'Alias',
            label: 'Sampling Point Alias',
            type: 'String'
        },
    ],
    'project': [
        {
            value: 'APINumber',
            label: 'Facility Number',
            type: 'String'
        },
        {
            value: 'Alias',
            label: 'Facility Alias',
            type: 'String'
        }
    ]
}